import React, { useState } from 'react';
import '../assets/styles/game.css';
import { useNavigate, useParams } from 'react-router-dom';

const questions = [
    { question: 'Pertanyaan 1', options: ['A1', 'B1', 'C1', 'D1', 'E1'], correct: 'A1' },
    { question: 'Pertanyaan 2', options: ['A2', 'B2', 'C2', 'D2', 'E2'], correct: 'B2' },
    { question: 'Pertanyaan 3', options: ['A3', 'B3', 'C3', 'D3', 'E3'], correct: 'C3' },
    { question: 'Pertanyaan 4', options: ['A4', 'B4', 'C4', 'D4', 'E4'], correct: 'D4' },
    { question: 'Pertanyaan 5', options: ['A5', 'B5', 'C5', 'D5', 'E5'], correct: 'E5' },
];

export default function Games() {
    const navigate = useNavigate();
    const [current, setCurrent] = useState(0);
    const [popup, setPopup] = useState(null);
    const { day } = useParams();
    const [answered, setAnswered] = useState(Array(questions.length).fill(false));
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedAnswers, setSelectedAnswers] = useState(Array(questions.length).fill(null));
    const [score, setScore] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);


    const nextQuestion = () => {
        if (current < questions.length - 1) setCurrent(current + 1);
    };

    const prevQuestion = () => {
        if (current > 0) setCurrent(current - 1);
    };

    const handleBackClick = () => {
        navigate(`/startgames/${day}`);
    };

    // buat handle submit jawaban dan cuman bisa sekali jawab di setiap soal
    const submitAnswer = () => {
        if (answered[current] || selectedOption === null) return;
    
        if (selectedOption === questions[current].correct) {
            setPopup({ type: 'correct' });
            setScore(score + 1);
        } else {
            setPopup({ type: 'wrong', correct: questions[current].correct });
        }
        setPopupOpen(true);
    
        const updatedAnswered = [...answered];
        updatedAnswered[current] = true;
        setAnswered(updatedAnswered);
    
        const updatedSelectedAnswers = [...selectedAnswers];
        updatedSelectedAnswers[current] = selectedOption;
        setSelectedAnswers(updatedSelectedAnswers);
      };
    
    
    const closePopup = () => {
        setPopup(null);
        setSelectedOption(null);
        setPopupOpen(false);
    };

    const progressPercentage = ((answered.filter(a => a).length) / questions.length) * 100;
    const finalScore = Math.round((score / questions.length) * 100);

    return (
        <div className="games-container">
        <div className="header">
        <div className="back-button" onClick={() => handleBackClick()}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="#CCA4CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
            <h1 className="games-title">Games</h1>
        </div>
        <div className="progress-bar-container">
            <div className="progress-bar" style={{ width: `${progressPercentage}%` }}></div>
        </div>

        {answered.every(a => a) ? (
            <div className="score-display">
            <h2>Skor Akhir:</h2>
            <p> {finalScore}</p>
            </div>
        ) : (
            <>
            <div className="question-card">
                <div className="question-label">Soal {current + 1}</div>
                <p className="question-text">{questions[current].question}</p>
            </div>
            {questions[current].options.map((option, index) => (
                <button
                key={index}
                className={`answer-button ${(selectedOption === option || selectedAnswers[current] === option) ? 'selected' : ''}`}
                onClick={() => !answered[current] && setSelectedOption(option)}
                disabled={answered[current]}
                >
                {option}
                </button>
            ))}
            <button className="submit-button" onClick={submitAnswer} disabled={answered[current] || selectedOption === null}>
                Submit Jawaban
            </button>
            <div className="navigation-buttons">
                <button onClick={prevQuestion} disabled={current === 0 || popupOpen} className="nav-button">Previous</button>
                <button onClick={nextQuestion} disabled={current === questions.length - 1 || popupOpen} className="nav-button">Next</button>
            </div>
            </>
        )}

        {popup && (
            <div className="popup">
            <button className="close-popup" onClick={closePopup}>X</button>
            {popup.type === 'correct' ? (
                <h2>Benar!</h2>
            ) : (
                <>
                <h2>Salah!</h2>
                <p>Jawaban yang benar adalah {popup.correct}</p>
                </>
            )}
            </div>
        )}
        </div>
    );
}
